import { render, staticRenderFns } from "./BulkRateChange.vue?vue&type=template&id=13cc8329&scoped=true"
import script from "./BulkRateChange.vue?vue&type=script&lang=js"
export * from "./BulkRateChange.vue?vue&type=script&lang=js"
import style0 from "./BulkRateChange.vue?vue&type=style&index=0&id=13cc8329&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc8329",
  null
  
)

export default component.exports